/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { AuthCodeResponseGenericResponse } from '../models/auth-code-response-generic-response';
import { AuthenticatedRequestDto } from '../models/authenticated-request-dto';
import { BurnSessionRequestDto } from '../models/burn-session-request-dto';
import { CustomerProfileDto } from '../models/customer-profile-dto';
import { CustomerProfileDtoGenericResponse } from '../models/customer-profile-dto-generic-response';
import { OrderHistoryDtoGenericResponse } from '../models/order-history-dto-generic-response';
import { OrderInfoRequest } from '../models/order-info-request';
import { OrdersHistoryAuthenticatedRequestDto } from '../models/orders-history-authenticated-request-dto';
import { ProfileRequestDto } from '../models/profile-request-dto';
import { RequestAuthCodeDto } from '../models/request-auth-code-dto';
import { RequestRegisterCustomerDto } from '../models/request-register-customer-dto';
import { UnitGenericResponse } from '../models/unit-generic-response';

@Injectable({ providedIn: 'root' })
export class CustomerService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiV1CustomerRequestAuthCodePost()` */
  static readonly ApiV1CustomerRequestAuthCodePostPath = '/api/v1/customer/request-auth-code';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV1CustomerRequestAuthCodePost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiV1CustomerRequestAuthCodePost$Plain$Response(
    params?: {
      body?: RequestAuthCodeDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<AuthCodeResponseGenericResponse>> {
    const rb = new RequestBuilder(this.rootUrl, CustomerService.ApiV1CustomerRequestAuthCodePostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: 'text/plain', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<AuthCodeResponseGenericResponse>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV1CustomerRequestAuthCodePost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiV1CustomerRequestAuthCodePost$Plain(
    params?: {
      body?: RequestAuthCodeDto
    },
    context?: HttpContext
  ): Observable<AuthCodeResponseGenericResponse> {
    return this.apiV1CustomerRequestAuthCodePost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<AuthCodeResponseGenericResponse>): AuthCodeResponseGenericResponse => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV1CustomerRequestAuthCodePost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiV1CustomerRequestAuthCodePost$Json$Response(
    params?: {
      body?: RequestAuthCodeDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<AuthCodeResponseGenericResponse>> {
    const rb = new RequestBuilder(this.rootUrl, CustomerService.ApiV1CustomerRequestAuthCodePostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'text/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<AuthCodeResponseGenericResponse>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV1CustomerRequestAuthCodePost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiV1CustomerRequestAuthCodePost$Json(
    params?: {
      body?: RequestAuthCodeDto
    },
    context?: HttpContext
  ): Observable<AuthCodeResponseGenericResponse> {
    return this.apiV1CustomerRequestAuthCodePost$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<AuthCodeResponseGenericResponse>): AuthCodeResponseGenericResponse => r.body)
    );
  }

  /** Path part for operation `apiV1CustomerRegisterPost()` */
  static readonly ApiV1CustomerRegisterPostPath = '/api/v1/customer/register';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV1CustomerRegisterPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiV1CustomerRegisterPost$Plain$Response(
    params?: {
      body?: RequestRegisterCustomerDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<AuthCodeResponseGenericResponse>> {
    const rb = new RequestBuilder(this.rootUrl, CustomerService.ApiV1CustomerRegisterPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: 'text/plain', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<AuthCodeResponseGenericResponse>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV1CustomerRegisterPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiV1CustomerRegisterPost$Plain(
    params?: {
      body?: RequestRegisterCustomerDto
    },
    context?: HttpContext
  ): Observable<AuthCodeResponseGenericResponse> {
    return this.apiV1CustomerRegisterPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<AuthCodeResponseGenericResponse>): AuthCodeResponseGenericResponse => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV1CustomerRegisterPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiV1CustomerRegisterPost$Json$Response(
    params?: {
      body?: RequestRegisterCustomerDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<AuthCodeResponseGenericResponse>> {
    const rb = new RequestBuilder(this.rootUrl, CustomerService.ApiV1CustomerRegisterPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'text/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<AuthCodeResponseGenericResponse>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV1CustomerRegisterPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiV1CustomerRegisterPost$Json(
    params?: {
      body?: RequestRegisterCustomerDto
    },
    context?: HttpContext
  ): Observable<AuthCodeResponseGenericResponse> {
    return this.apiV1CustomerRegisterPost$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<AuthCodeResponseGenericResponse>): AuthCodeResponseGenericResponse => r.body)
    );
  }

  /** Path part for operation `apiV1CustomerSessionAuthPost()` */
  static readonly ApiV1CustomerSessionAuthPostPath = '/api/v1/customer/session/auth';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV1CustomerSessionAuthPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiV1CustomerSessionAuthPost$Plain$Response(
    params?: {
      body?: ProfileRequestDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<CustomerProfileDtoGenericResponse>> {
    const rb = new RequestBuilder(this.rootUrl, CustomerService.ApiV1CustomerSessionAuthPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: 'text/plain', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CustomerProfileDtoGenericResponse>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV1CustomerSessionAuthPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiV1CustomerSessionAuthPost$Plain(
    params?: {
      body?: ProfileRequestDto
    },
    context?: HttpContext
  ): Observable<CustomerProfileDtoGenericResponse> {
    return this.apiV1CustomerSessionAuthPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomerProfileDtoGenericResponse>): CustomerProfileDtoGenericResponse => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV1CustomerSessionAuthPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiV1CustomerSessionAuthPost$Json$Response(
    params?: {
      body?: ProfileRequestDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<CustomerProfileDtoGenericResponse>> {
    const rb = new RequestBuilder(this.rootUrl, CustomerService.ApiV1CustomerSessionAuthPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'text/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CustomerProfileDtoGenericResponse>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV1CustomerSessionAuthPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiV1CustomerSessionAuthPost$Json(
    params?: {
      body?: ProfileRequestDto
    },
    context?: HttpContext
  ): Observable<CustomerProfileDtoGenericResponse> {
    return this.apiV1CustomerSessionAuthPost$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomerProfileDtoGenericResponse>): CustomerProfileDtoGenericResponse => r.body)
    );
  }

  /** Path part for operation `apiV1CustomerSessionFetchPost()` */
  static readonly ApiV1CustomerSessionFetchPostPath = '/api/v1/customer/session/fetch';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV1CustomerSessionFetchPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiV1CustomerSessionFetchPost$Plain$Response(
    params?: {
      ignoreCache?: boolean;
      body?: AuthenticatedRequestDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<CustomerProfileDtoGenericResponse>> {
    const rb = new RequestBuilder(this.rootUrl, CustomerService.ApiV1CustomerSessionFetchPostPath, 'post');
    if (params) {
      rb.query('ignoreCache', params.ignoreCache, {});
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: 'text/plain', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CustomerProfileDtoGenericResponse>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV1CustomerSessionFetchPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiV1CustomerSessionFetchPost$Plain(
    params?: {
      ignoreCache?: boolean;
      body?: AuthenticatedRequestDto
    },
    context?: HttpContext
  ): Observable<CustomerProfileDtoGenericResponse> {
    return this.apiV1CustomerSessionFetchPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomerProfileDtoGenericResponse>): CustomerProfileDtoGenericResponse => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV1CustomerSessionFetchPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiV1CustomerSessionFetchPost$Json$Response(
    params?: {
      ignoreCache?: boolean;
      body?: AuthenticatedRequestDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<CustomerProfileDtoGenericResponse>> {
    const rb = new RequestBuilder(this.rootUrl, CustomerService.ApiV1CustomerSessionFetchPostPath, 'post');
    if (params) {
      rb.query('ignoreCache', params.ignoreCache, {});
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'text/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CustomerProfileDtoGenericResponse>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV1CustomerSessionFetchPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiV1CustomerSessionFetchPost$Json(
    params?: {
      ignoreCache?: boolean;
      body?: AuthenticatedRequestDto
    },
    context?: HttpContext
  ): Observable<CustomerProfileDtoGenericResponse> {
    return this.apiV1CustomerSessionFetchPost$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomerProfileDtoGenericResponse>): CustomerProfileDtoGenericResponse => r.body)
    );
  }

  /** Path part for operation `apiV1CustomerUpdatePost()` */
  static readonly ApiV1CustomerUpdatePostPath = '/api/v1/customer/update';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV1CustomerUpdatePost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiV1CustomerUpdatePost$Plain$Response(
    params?: {
      body?: CustomerProfileDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<CustomerProfileDtoGenericResponse>> {
    const rb = new RequestBuilder(this.rootUrl, CustomerService.ApiV1CustomerUpdatePostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: 'text/plain', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CustomerProfileDtoGenericResponse>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV1CustomerUpdatePost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiV1CustomerUpdatePost$Plain(
    params?: {
      body?: CustomerProfileDto
    },
    context?: HttpContext
  ): Observable<CustomerProfileDtoGenericResponse> {
    return this.apiV1CustomerUpdatePost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomerProfileDtoGenericResponse>): CustomerProfileDtoGenericResponse => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV1CustomerUpdatePost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiV1CustomerUpdatePost$Json$Response(
    params?: {
      body?: CustomerProfileDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<CustomerProfileDtoGenericResponse>> {
    const rb = new RequestBuilder(this.rootUrl, CustomerService.ApiV1CustomerUpdatePostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'text/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CustomerProfileDtoGenericResponse>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV1CustomerUpdatePost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiV1CustomerUpdatePost$Json(
    params?: {
      body?: CustomerProfileDto
    },
    context?: HttpContext
  ): Observable<CustomerProfileDtoGenericResponse> {
    return this.apiV1CustomerUpdatePost$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomerProfileDtoGenericResponse>): CustomerProfileDtoGenericResponse => r.body)
    );
  }

  /** Path part for operation `apiV1CustomerSessionBurnPost()` */
  static readonly ApiV1CustomerSessionBurnPostPath = '/api/v1/customer/session/burn';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV1CustomerSessionBurnPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiV1CustomerSessionBurnPost$Plain$Response(
    params?: {
      body?: BurnSessionRequestDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<UnitGenericResponse>> {
    const rb = new RequestBuilder(this.rootUrl, CustomerService.ApiV1CustomerSessionBurnPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: 'text/plain', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<UnitGenericResponse>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV1CustomerSessionBurnPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiV1CustomerSessionBurnPost$Plain(
    params?: {
      body?: BurnSessionRequestDto
    },
    context?: HttpContext
  ): Observable<UnitGenericResponse> {
    return this.apiV1CustomerSessionBurnPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<UnitGenericResponse>): UnitGenericResponse => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV1CustomerSessionBurnPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiV1CustomerSessionBurnPost$Json$Response(
    params?: {
      body?: BurnSessionRequestDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<UnitGenericResponse>> {
    const rb = new RequestBuilder(this.rootUrl, CustomerService.ApiV1CustomerSessionBurnPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'text/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<UnitGenericResponse>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV1CustomerSessionBurnPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiV1CustomerSessionBurnPost$Json(
    params?: {
      body?: BurnSessionRequestDto
    },
    context?: HttpContext
  ): Observable<UnitGenericResponse> {
    return this.apiV1CustomerSessionBurnPost$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<UnitGenericResponse>): UnitGenericResponse => r.body)
    );
  }

  /** Path part for operation `apiV1CustomerOrdersHistoryPost()` */
  static readonly ApiV1CustomerOrdersHistoryPostPath = '/api/v1/customer/orders/history';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV1CustomerOrdersHistoryPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiV1CustomerOrdersHistoryPost$Plain$Response(
    params?: {
      body?: OrdersHistoryAuthenticatedRequestDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<OrderHistoryDtoGenericResponse>> {
    const rb = new RequestBuilder(this.rootUrl, CustomerService.ApiV1CustomerOrdersHistoryPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: 'text/plain', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<OrderHistoryDtoGenericResponse>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV1CustomerOrdersHistoryPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiV1CustomerOrdersHistoryPost$Plain(
    params?: {
      body?: OrdersHistoryAuthenticatedRequestDto
    },
    context?: HttpContext
  ): Observable<OrderHistoryDtoGenericResponse> {
    return this.apiV1CustomerOrdersHistoryPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<OrderHistoryDtoGenericResponse>): OrderHistoryDtoGenericResponse => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV1CustomerOrdersHistoryPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiV1CustomerOrdersHistoryPost$Json$Response(
    params?: {
      body?: OrdersHistoryAuthenticatedRequestDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<OrderHistoryDtoGenericResponse>> {
    const rb = new RequestBuilder(this.rootUrl, CustomerService.ApiV1CustomerOrdersHistoryPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'text/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<OrderHistoryDtoGenericResponse>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV1CustomerOrdersHistoryPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiV1CustomerOrdersHistoryPost$Json(
    params?: {
      body?: OrdersHistoryAuthenticatedRequestDto
    },
    context?: HttpContext
  ): Observable<OrderHistoryDtoGenericResponse> {
    return this.apiV1CustomerOrdersHistoryPost$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<OrderHistoryDtoGenericResponse>): OrderHistoryDtoGenericResponse => r.body)
    );
  }

  /** Path part for operation `apiV1CustomerOrdersPost()` */
  static readonly ApiV1CustomerOrdersPostPath = '/api/v1/customer/orders';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV1CustomerOrdersPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   *
   * @deprecated
   */
  apiV1CustomerOrdersPost$Plain$Response(
    params?: {
      body?: OrderInfoRequest
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<OrderHistoryDtoGenericResponse>> {
    const rb = new RequestBuilder(this.rootUrl, CustomerService.ApiV1CustomerOrdersPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: 'text/plain', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<OrderHistoryDtoGenericResponse>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV1CustomerOrdersPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   *
   * @deprecated
   */
  apiV1CustomerOrdersPost$Plain(
    params?: {
      body?: OrderInfoRequest
    },
    context?: HttpContext
  ): Observable<OrderHistoryDtoGenericResponse> {
    return this.apiV1CustomerOrdersPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<OrderHistoryDtoGenericResponse>): OrderHistoryDtoGenericResponse => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV1CustomerOrdersPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   *
   * @deprecated
   */
  apiV1CustomerOrdersPost$Json$Response(
    params?: {
      body?: OrderInfoRequest
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<OrderHistoryDtoGenericResponse>> {
    const rb = new RequestBuilder(this.rootUrl, CustomerService.ApiV1CustomerOrdersPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'text/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<OrderHistoryDtoGenericResponse>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV1CustomerOrdersPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   *
   * @deprecated
   */
  apiV1CustomerOrdersPost$Json(
    params?: {
      body?: OrderInfoRequest
    },
    context?: HttpContext
  ): Observable<OrderHistoryDtoGenericResponse> {
    return this.apiV1CustomerOrdersPost$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<OrderHistoryDtoGenericResponse>): OrderHistoryDtoGenericResponse => r.body)
    );
  }

}
